<div
  class="loyalty-grid-container px-3 search-holder"
  *ngIf="isLoyaltyRewardsVisible"
>
  <ul class="list-inline grid-top-actions mb-3">
    <li class="list-inline-item ">
      <input
        type="text"
        placeholder="{{ 'pages.newRetailer.search' | translate }}"
        matInput
        class="
          rounded-pill
          px-3
          py-2
          mb-0
          border-0
          bg-light
          w-100
          me-0
          input-search
          ms-3
        "
        (keyup)="quickSearch()"
        [(ngModel)]="searchValue"
      />
      <i
        color="primary"
        class="search-icon-holder"
        matSuffix
        mat-icon-button
        aria-label="Search"
      >
        <mat-icon>search</mat-icon>
      </i>
    </li>

    <li *ngIf="!isButtonDisabled" class="list-inline-item float-end me-2">
      <button
        mat-stroked-button
        [disabled]="!showEditPromotion"
        class="bg-theme mx-2"
        (click)="editPromotions()"
      >
        {{ "pages.newRetailer.edit" | translate }}
        <i class="mi mi-drive-file-rename-outline"></i>
      </button>
    </li>
    <!--<li class="list-inline-item float-end">
      <button
        mat-stroked-button
        class="bg-theme   mx-2"
        (click)="addPromotionConfig()"
      >
        Add <i class="mi mi-add"></i>
      </button>
    </li> -->
  </ul>
  <div class="report-grid">
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      class="ag-theme-material"
      [rowHeight]="40"
      [enableFilter]="true"
      [enableSorting]="true"
      [enableColResize]="true"
      [rowSelection]="'single'"
      [rowData]="loyaltyPromotionsData"
      [columnDefs]="loyalityPromotionsColumnDef"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>

<div class="row">
  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
    <div class="loyalty-grid-container px-3" *ngIf="isLoyaltyEditVisible">
      <mat-card class="p-2">
        <div class="label-holder">
          <span class="content-label">
            <span translate>{{ formAction }}</span><span> {{ 'pages.placeholders.loyaltypromotion' | translate }}</span></span
          >
          <span
            (click)="return()"
            class="cur-point float-end d-inline-block me-3"
            >{{'pages.placeholders.Back' | translate }}
            <span
              ><mat-icon class="float-end" class="inverted-left"
                >forward</mat-icon
              >
            </span></span
          >
        </div>
        <div class="generate-promocode-form-container">
          <form
            (ngSubmit)="onLoyaltyFormSubmit()"
            [formGroup]="loyaltyPromocodesForm"
          >
            <div class="form-container">
              <!--<div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    Product <span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="codeGroup" required>
                        <mat-option
                          *ngFor="let codeGroup of codeGroups"
                          [value]="codeGroup"
                          >{{ codeGroup }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="f.codeGroup.touched && f.codeGroup.invalid">
                      <div *ngIf="f.codeGroup.errors.required">
                        <mat-hint class="text-danger ms-2">
                          Code Group is required.</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label" translate>
                    Country <span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select
                        [formControl]="countryControl"
                        required
                        multiple
                      >
                      <mat-option #allSelected (click)="toggleAllSelection()" [value]="0"> &nbsp; &nbsp;</mat-option>
                        <mat-option
                          *ngFor="let item of countriesList"
                          [value]="item"
                          (click)="tosslePerOne(allSelected)"
                        >
                          {{ item }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="f.country.touched && f.country.invalid">
                      <div *ngIf="f.country.errors.required">
                        <mat-hint class="text-danger ms-2">
                          carrier is required.</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label">
                    {{'pages.RewardsConfiguration.Tier' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field appearance="outline">
                      <mat-select formControlName="tier" required disabled>
                        <mat-option *ngFor="let tierPlan of tiers" [value]="tierPlan">{{tierPlan}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="f.tier.touched && f.tier.invalid">
                      <div *ngIf="f.tier.errors.required">
                        <mat-hint class="text-danger ms-2">
                          Tier is required.</mat-hint
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label">
                    # {{'pages.placeholders.OfLoyaltyPoints' | translate }}<span class="required">*</span>
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field class="" appearance="outline">
                      <input
                        matInput
                        type="text"
                        required
                        placeholder="{{'pages.placeholders.EnterPoints' | translate }}"
                        formControlName="points"
                        readonly
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row my-2">
                <div
                  class="col-lg-5 col-md-5 col-sm-5 col-xs-12 align-self-center"
                >
                  <h4 class="form-item-label">
                    {{'pages.placeholders.AmountAppliedForLoyaltyPoints' | translate }}<span class="required"
                      >*</span
                    >
                  </h4>
                </div>
                <div
                  class="col-lg-7 col-md-7 col-sm-7 col-xs-12 align-self-center"
                >
                  <div class="form-item-input">
                    <mat-form-field class="" appearance="outline">
                      <input
                        matInput
                        type="text"
                        required
                        placeholder="{{'pages.Managefunds.Enteramount' | translate }}"
                        formControlName="amount"
                        required
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-footer">
              <ul class="list-inline text-center">
                <li class="list-inline-item">
                  <button
                    mat-raised-button
                    [disabled]="checkSubmitDisplayed()"
                    color="primary"
                    type="submit"
                  >
                    <span translate class="translate">{{ submitLabel }}</span>
                  </button>
                </li>
                <li class="list-inline-item">
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="onCancel()"
                  >
                    <span class="translate">{{ 'pages.newRetailer.cancel' | translate }}</span>
                  </button>
                </li>
              </ul>
            </div>
          </form>
        </div>
      </mat-card>
    </div>
  </div>
</div>
